<app-loader *ngIf="isLoading"></app-loader>
<form method="post" *ngIf="!isLoading" [formGroup]="studentForm">
  <div class="row">
    <div class="col-6" id="student-edit-personal-info">
      <div class="form-group">
        <label for="registrationNumber">Nyílvántartási szám</label>
        <input type="text" id="registrationNumber" class="form-control" formControlName="registrationNumber" />
        <div *ngIf="registrationNumber.invalid && (registrationNumber.dirty || registrationNumber.touched)"
             class="alert alert-danger">
          <div *ngIf="registrationNumber.errors?.['serverError']">
            {{registrationNumber.errors?.['serverError']}}
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="title">Titulus</label>
        <input type="text" id="title" class="form-control" formControlName="title" />
        <div *ngIf="title.invalid && (title.dirty || title.touched)" class="alert alert-danger">
          <div *ngIf="title.errors?.['serverError']">{{title.errors?.['serverError']}}</div>
        </div>
      </div>
      <div class="form-group">
        <label for="surname">Vezetéknév<span class="required-label" *ngIf="surname.errors?.['required']">*</span></label>
        <input type="text" id="surname" class="form-control" formControlName="surname" />
        <div *ngIf="surname.invalid && (surname.dirty || surname.touched)" class="alert alert-danger">
          <div *ngIf="surname.errors?.['required']">A vezetéknév kötelező.</div>
          <div *ngIf="surname.errors?.['serverError']">{{surname.errors?.['serverError']}}</div>
        </div>
      </div>
      <div class="form-group">
        <label for="forename">Keresztnév 1<span class="required-label" *ngIf="forename.errors?.['required']">*</span></label>
        <input type="text" id="forename" class="form-control" formControlName="forename" />
        <div *ngIf="forename.invalid && (forename.dirty || forename.touched)" class="alert alert-danger">
          <div *ngIf="forename.errors?.['required']">A keresztnév kötelező.</div>
          <div *ngIf="forename.errors?.['serverError']">{{forename.errors?.['serverError']}}</div>
        </div>
      </div>
      <div class="form-group">
        <label for="forename2">Keresztnév 2</label>
        <input type="text" id="forename2" class="form-control" formControlName="forename2" />
        <div *ngIf="forename2.invalid && (forename2.dirty || forename2.touched)" class="alert alert-danger">
          <div *ngIf="forename2.errors?.['serverError']">{{forename2.errors?.['serverError']}}</div>
        </div>
      </div>
      <div class="form-group">
        <label for="citizenship">Állampolgárság</label>
        <input type="text" id="citizenship" class="form-control" formControlName="citizenship" />
        <div *ngIf="citizenship.invalid && (citizenship.dirty || citizenship.touched)" class="alert alert-danger">
          <div *ngIf="citizenship.errors?.['serverError']">{{citizenship.errors?.['serverError']}}</div>
        </div>
      </div>
      <div class="form-group">
        <label for="mothersName">Anyja neve</label>
        <input type="text" id="mothersName" class="form-control" formControlName="mothersName" />
        <div *ngIf="mothersname.invalid && (mothersname.dirty || mothersname.touched)" class="alert alert-danger">
          <div *ngIf="mothersname.errors?.['serverError']">{{mothersname.errors?.['serverError']}}</div>
        </div>
      </div>
      <div class="form-group">
        <label for="birthplace">Születési hely<span class="required-label" *ngIf="birthplace.errors?.['required']">*</span></label>
        <input type="text" id="birthplace" class="form-control" formControlName="birthplace" />
        <div *ngIf="birthplace.invalid && (birthplace.dirty || birthplace.touched)" class="alert alert-danger">
          <div *ngIf="birthplace.errors?.['required']">A születési hely kötelező.</div>
          <div *ngIf="birthplace.errors?.['serverError']">{{birthplace.errors?.['serverError']}}</div>
        </div>
      </div>
      <div class="form-group">
        <label for="birthdate">Születési idő<span class="required-label" *ngIf="birthdate.errors?.['required']">*</span></label>
        <input type="text" id="birthdate" class="form-control" formControlName="birthdate" appDatePicker />
      </div>
      <div *ngIf="birthdate.invalid && (birthdate.dirty || birthdate.touched)" class="alert alert-danger">
        <div *ngIf="birthdate.errors?.['required']">A születési idő kötelező.</div>
        <div *ngIf="birthdate.errors?.['future']">A születési idő nem lehet jövőbeli időpont.</div>
        <div *ngIf="birthdate.errors?.['serverError']">{{birthdate.errors?.['serverError']}}</div>
      </div>
      <div class="form-group">
        <label for="birthName">Születési név</label>
        <input type="text" id="birthName" class="form-control" formControlName="birthName" />
        <div *ngIf="birthName.invalid && (birthName.dirty || birthName.touched)" class="alert alert-danger">
          <div *ngIf="birthName.errors?.['serverError']">{{birthName.errors?.['serverError']}}</div>
        </div>
      </div>
      <div class="form-group">
        <label for="email">Email cím<span class="required-label" *ngIf="email.errors?.['required']">*</span></label>
        <input type="text" id="email" class="form-control" formControlName="email" />
        <div *ngIf="email.invalid && (email.dirty || email.touched)" class="alert alert-danger">
          <div *ngIf="email.errors?.['pattern']">Nem megfelelő email formátum.</div>
          <div *ngIf="email.errors?.['minlength']">Az email-nek legalább 5 karakter hosszúnak kell lennie.</div>
          <div *ngIf="email.errors?.['required']">Az email kötelező.</div>
          <div *ngIf="email.errors?.['serverError']">{{email.errors?.['serverError']}}</div>
        </div>
      </div>
    </div>
    <div class="col-6" id="student-edit-exam-info">
      <div class="form-group">
        <label for="computerNumber">Vizsga gép<span class="required-label" *ngIf="computerNumber.errors?.['required']">*</span></label>
        <input type="number" id="computerNumber" class="form-control" formControlName="computerNumber" min="0" />
        <div *ngIf="computerNumber.invalid && (computerNumber.dirty || computerNumber.touched)"
             class="alert alert-danger">
          <div *ngIf="computerNumber.errors?.['required']">A vizsgagépet kötelező megadni.</div>
          <div *ngIf="computerNumber.errors?.['min']">A vizsgagép nem lehet negatív szám.</div>
          <div *ngIf="computerNumber.errors?.['serverError']">{{computerNumber.errors?.['serverError']}}</div>
        </div>
      </div>
      <div class="form-group">
        <label>Vizsgázó nyelve<span class="required-label" *ngIf="language.errors?.['required']">*</span></label>
        <ng-select placeholder="Kérem válasszon..." notFoundText="Nincs találat!" formControlName="language">
          <ng-option *ngFor="let option of languageSelectList.items" [value]="option.value">
            {{ option.text }}
          </ng-option>
        </ng-select>
        <div *ngIf="language.invalid && (language.dirty || language.touched)" class="alert alert-danger">
          <div *ngIf="language.errors?.['required']">A nyelvet kötelező megadni.</div>
          <div *ngIf="language.errors?.['serverError']">{{language.errors?.['serverError']}}</div>
        </div>
      </div>
      <div class="form-group">
        <label for="examStartedAtUtc">
          Vizsga kezdés időpontja<span class="required-label" *ngIf="examStartedAtUtc.errors?.['required']">*</span>
        </label>
        <input id="examStartedAtUtc"
               class="form-control datetimepicker"
               formControlName="examStartedAtUtc"
               appDateTimePicker />
        <div *ngIf="examStartedAtUtc.invalid && (examStartedAtUtc.dirty || examStartedAtUtc.touched)"
             class="alert alert-danger">
          <div *ngIf="examStartedAtUtc.errors?.['required']">A vizsga kezdés időpontját kötelező megadni.</div>
          <div *ngIf="examStartedAtUtc.errors?.['serverError']">{{examStartedAtUtc.errors?.['serverError']}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="button-group">
    <button (click)="onSubmit()" class="btn btn-primary text-white btn-save me-2" [disabled]="studentForm.invalid">
      Mentés
    </button>
    <a (click)="onGoBack()" class="btn btn-dark"> Vissza </a>
  </div>
</form>
